import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

export const HomeNews = () => {
  const [NewsUser, setNewsUser] = useState([]);

  //   News top api
  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get("https://admin.gosaviadvanceddentalclinic.com/api/getnews");
      setNewsUser(response.data);
    };

    fetchData();
  }, []);

  return (
    <div className="container homeBanner-details">
      <div className="row arpi">
        <div className="col-lg-2 col-md-2 col-sm-12"></div>

        <div className="col-lg-10 col-md-10 col-sm-12 view-home">
          {/* <Link to="/News-add">
            <button className="Banner-button">Add</button>
          </Link> */}
          {NewsUser.map((user) => {
            return (
              <div className="news">
                <h3>
                  {user.heading}{" "}
                  <Link to={`/News-edit/` + user.id}>
                    {" "}
                    <i className="fa-regular fa-pen-to-square action-btn"></i>
                  </Link>
                </h3>
                <p>{user.para}</p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export const NewsAdd = () => {
  const [NewsData, setNewsData] = useState({
    heading: "",
    para: "",
  });

  const navigate = useNavigate();

  const inputHandler = (e) => {
    const { name, value } = e.target;
    setNewsData((prev) => ({ ...prev, [name]: value }));
  };

  const submitForm = async (e) => {
    e.preventDefault();

    try {
      await axios.post("https://admin.gosaviadvanceddentalclinic.com/api/createnews", NewsData);

      toast.success("Data added successfully!");
      navigate("/News");
    } catch (error) {
      console.error("Error adding News:", error);
      toast.error("Failed to add News!");
    }
  };

  return (
    <div className="container add-page">
      <div className="row">
        <div className="col-lg-2 col-md-2 col-sm-12" />
        <div className="col-lg-10 col-md-10 col-sm-12 add-details">
          <div className="add-banner">
            <Link to="/News">
              <i className="fa-solid fa-xmark"></i>
            </Link>
            <h3>Add News Data</h3>
            <form
              className="row"
              onSubmit={submitForm}
              encType="multipart/form-data"
            >
              <div className="col-lg-12 col-md-12 col-sm-12 inputform">
                <label htmlFor="heading">Heading</label>
                <input
                  type="text"
                  onChange={inputHandler}
                  value={NewsData.heading}
                  id="heading"
                  name="heading"
                  placeholder="Enter Heading"
                />
              </div>

              <div className="col-lg-12 col-md-12 col-sm-12 inputform">
                <label htmlFor="para">Paragraph</label>
                <textarea
                  onChange={inputHandler}
                  value={NewsData.para}
                  id="para"
                  name="para"
                  placeholder="Enter Paragraph"
                  rows="4"
                ></textarea>
              </div>
              <div className="mobilesubmitform">
                <button type="submit">Add Data</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export const NewsEdit = () => {
  const [Newsuser, setNewsUser] = useState({
    heading: "",
    para: "",
  });
  const { id } = useParams();
  const navigate = useNavigate();

  const changeHandler = (e) => {
    const { name, value } = e.target;
    setNewsUser({ ...Newsuser, [name]: value });
    // console.log(user);
  };

  useEffect(() => {
    const editData = async () => {
      try {
        const response = await axios.get(
          `https://admin.gosaviadvanceddentalclinic.com/api/getonenews/${id}`
        );
        // console.log(response.data);
        setNewsUser(response.data.data);
      } catch (error) {
        console.error("There was an error!", error);
      }
    };
    editData();
  }, [id]);

  const submitForm = async (e) => {
    e.preventDefault();

    const formData = {
      heading: Newsuser.heading,
      para: Newsuser.para,
    };

    try {
      const response = await axios.put(
        `https://admin.gosaviadvanceddentalclinic.com/api/updatenews/${id}`,
        formData,
        { headers: { "Content-Type": "application/json" } }
      );
      if (response.data.success) {
        setNewsUser(formData);
        toast.success("Data updated successfully!");
        navigate("/News");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("There was an error!", error);
    }
  };

  return (
    <div
      className="modal fade show"
      id="update_heading"
      tabIndex={-1}
      role="dialog"
      aria-labelledby="exampleModalLabel"
      style={{
        display: "block",
        paddingRight: 18,
        marginTop: 90,
        paddingBottom: 50,
      }}
      aria-modal="true"
    >
      <div className="modal-dialog" role="document">
        <form onSubmit={submitForm}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Edit
              </h5>
              <Link to="/News">
                <button type="button" className="close" aria-label="Close">
                  <span aria-hidden="true">
                    <i className="fa-solid fa-xmark"></i>
                  </span>
                </button>
              </Link>
            </div>

            <div className="modal-body">
              <div className="form-group">
                <label>Heading</label>
                <input
                  type="text"
                  value={Newsuser.heading}
                  onChange={changeHandler}
                  className="form-control"
                  name="heading"
                />
                <br />
              </div>

              <div className="form-group">
                <label>Paragraph</label>
                <textarea
                  type="text"
                  value={Newsuser.para}
                  onChange={changeHandler}
                  className="form-control"
                  name="para"
                  rows={6}
                />
                <br />
              </div>
            </div>

            <div className="modal-footer">
              <Link to="/News">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Close
                </button>
              </Link>
              <button type="submit" className="btn btn-primary">
                Update
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
